<div class="workspace-conf-modal">
  <button class="close-button" (click)="closeModal()">
    <mat-icon svgIcon="close"></mat-icon>
    <span class="button-text2">ESC</span>
  </button>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12 title">
        <h2 class="title-text">PERSONALIZE SUA ÁREA DE TRABALHO</h2>
        <mat-icon class="title-icon" svgIcon="desktop"></mat-icon>
      </div>
    </div>
    <div class="info-text row">
      <div class="col-12 txt-center">
        {{ messageInfo1 }}
        <br>
        {{ messageInfo2 }}
      </div>
    </div>
    <ng-container *ngIf="!loading">
      <div class="input-title row">
        <div class="col-6">
          <mat-form-field>
            <input #inputCustomName matInput type="text" placeholder="digite nome personalizado"
              (keydown.enter)="submit()" [(ngModel)]="customNameWorkspace" size="51" maxlength="20" required>
          </mat-form-field>
        </div>
      </div>
      <div class="components-section row">
      <div class="col-6" *ngFor="let opt of wksOptions.slice()">
          <div id="{{ opt.id }}" class="select-pre-built" (click)="selectValue(opt.id)">
            <mat-icon class="icon" svgIcon={{opt.iconName}}></mat-icon>
            <span class="title">{{ opt.title }}</span>
            <span class="hidden-content">{{ opt.text }}</span>
          </div>
        </div>
      </div>
      <div class="buttons-section row justify-content-center">
        <button *ngIf="!loadingBtn" mat-raised-button color="primary01" [disabled]="!validateForm()"
          (click)="submit()">Iniciar</button>
        <app-spinner-loading *ngIf="loadingBtn"></app-spinner-loading>
      </div>
    </ng-container>
    <app-spinner-loading *ngIf="loading"></app-spinner-loading>
  </div>
</div>
